const main = () => {
    if(document.querySelector('.c-others-hamburger') === null) return;

    document.querySelectorAll('[data-open-hamburger]')
    .forEach(element => {
        element.addEventListener('click', (e) => {
            console.log('Hamburger toggled');
            e.preventDefault();
            document.body.toggleAttribute("data-menu-active")
        });
    });
}

export default main
